import { render, staticRenderFns } from "./budgetmodal.vue?vue&type=template&id=82bd8430"
import script from "./budgetmodal.vue?vue&type=script&lang=js"
export * from "./budgetmodal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports